import React, { useEffect, useState } from 'react';
import { pmApi } from '../../lib/pmApi';

const PmInvoices = () => {
  const [list, setList] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => { pmApi.invoices().then(setList).catch((e) => setErr(e.response?.data?.detail || e.message)); }, []);

  const STATUS_STYLE = {
    paid:       'bg-[#10B981]/15 text-[#10B981]',
    sent:       'bg-[#D4AF37]/15 text-[#D4AF37]',
    pending:    'bg-[#D4AF37]/15 text-[#D4AF37]',
    due:        'bg-[#F59E0B]/15 text-[#F59E0B]',
    past_due:   'bg-[#EF4444]/15 text-[#EF4444]',
    overdue:    'bg-[#EF4444]/15 text-[#EF4444]',
    draft:      'bg-[#525252]/30 text-[#A3A3A3]',
  };

  const downloadPdf = (invoice) => {
    const url = `${process.env.REACT_APP_BACKEND_URL}/api/invoices/${invoice.id}/pdf`;
    window.open(url, '_blank');
  };

  return (
    <div data-testid="pm-invoices-page" className="p-6 max-w-7xl space-y-6">
      <div>
        <p className="text-[#D4AF37] text-xs font-bold tracking-[0.3em] mb-1">INVOICES</p>
        <h1 className="font-['Outfit'] text-3xl font-bold text-white">Invoice Center</h1>
        <p className="text-[#A3A3A3] text-sm mt-1">{list.length} invoice{list.length === 1 ? '' : 's'} across your properties.</p>
      </div>
      {err && <p className="text-[#EF4444]">{err}</p>}
      <div className="bg-[#141414] border border-[#262626] rounded-md overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#0A0A0A] text-[#A3A3A3]">
            <tr>
              <th className="p-3 text-left">Invoice #</th>
              <th className="p-3 text-left">Service Location</th>
              <th className="p-3 text-left">Requested By</th>
              <th className="p-3 text-left">Bill To</th>
              <th className="p-3 text-left">Created</th>
              <th className="p-3 text-right">Amount</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {list.map((inv) => (
              <tr key={inv.id} data-testid={`pm-invoice-row-${inv.id}`} className="border-t border-[#262626] hover:bg-[#1a1a1a]">
                <td className="p-3 text-[#D4AF37] font-mono text-xs">{inv.invoice_number}</td>
                <td className="p-3">
                  <div className="text-white" data-testid={`pm-invoice-property-${inv.id}`}>{inv.property_name || inv.service_address || '—'}</div>
                  {inv.customer_name && <div className="text-[10px] text-[#A3A3A3]">{inv.customer_name}</div>}
                </td>
                <td className="p-3 text-cyan-300 text-xs">{inv.requester_name || '—'}</td>
                <td className="p-3 text-[#A3A3A3] text-xs">{inv.bill_to_name || '—'}</td>
                <td className="p-3 text-[#525252] text-xs">{inv.created_at ? new Date(inv.created_at).toLocaleDateString() : ''}</td>
                <td className="p-3 text-white text-right font-medium">${Number(inv.total || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                <td className="p-3">
                  <span className={`text-xs font-medium px-2 py-1 rounded ${STATUS_STYLE[inv.status] || 'bg-[#262626] text-[#A3A3A3]'}`}>{inv.status}</span>
                </td>
                <td className="p-3 text-right">
                  <button onClick={() => downloadPdf(inv)} data-testid={`pm-invoice-pdf-${inv.id}`} className="text-[#A3A3A3] hover:text-[#D4AF37] text-xs">PDF ↗</button>
                </td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan={8} className="p-6 text-center text-[#525252]">No invoices yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PmInvoices;
